import { AppBar, Box, Container } from '@mui/material';
import dynamic from 'next/dynamic';
import React from "react";
// import getPriceData from '../../../lib/stock/_getPriceData';
import getStockTabs from '../../../lib/stock/_getStockTabsData';
import getTickerInfo from '../../../lib/stock/_getTickerInfo';
import { dataConstants } from '../../../src/constants';
import { withProtected } from '../../../src/hook/route';
import { getTheme, isDesktop, searchTicker } from '../../../src/utils/helpers';
// import getHomeNews from '../../../lib/stock/_getHomeNews';
import getChartTheme from '../../../lib/charts/_getThemes';
import getPageMetaTags from '../../../lib/meta/_getMetaTags';
import TickerToolbar from '../../../src/components/_common/TickerToolbar';
// import getLatestFilings from "../../../lib/stock/_getLatestFilings";
import getStockAlerts from "../../../lib/stock/_getStockAlerts";
// import get13G from "../../../lib/stock/_get13GFilings";
// import get5YPriceData from "../../../lib/stock/_get5YPriceData";
import getEvents from "../../../lib/chart-maker/_getEvents";
import getPeriods from "../../../lib/chart-maker/_getPeriods";
import getTemplates from "../../../lib/chart-maker/_getTemplates";
// import getNewsfeed from "../../../lib/stock/_getHomeNews";
import getRevenues from "../../../lib/stock/_getRevenues";
import getStockFAQs from "../../../lib/stock/_getStockFAQs";
// import getStocksHeatMapData from "../../../lib/stock/_getTickerSectorHeatMapData";
import getTickerTextData from "../../../lib/stock/_getTickerTextData";
import getLatestFilings from '../../../lib/stock/_getLatestFilings';
import getWatchlistMetrics from '../../../lib/stock/_getWatchlistMetrics';

const Summary = dynamic(() => import('../../../src/components/Stock/TickerTabs/Summary'))
// const TickerToolbar = dynamic(() => import('../../../src/components/_common/TickerToolbar'))
// const BreadCrumb = dynamic(() => import('../../../src/components/_common/BreadCrumb'))

// import StockAppBar from '../../../src/components/_common/StockAppBar';

// function ShowAppBarOnScroll(props) {
//   const { children, window } = props;
//   const trigger = useScrollTrigger({
//     target: window ? window() : undefined,
//     disableHysteresis: true,
//     threshold: 188,
//   });

//   return (
//     <Slide direction="down" in={trigger}>
//       <Box
//         // onClick={handleClick}
//         role="presentation"
//         sx={{ position: 'fixed', top: 54, left: 0, bgcolor: 'background.paper', zIndex: 99, width: '100vw' }}
//       >
//         {children}
//       </Box>
//     </Slide>
//   );
// }

// ShowAppBarOnScroll.propTypes = {
//   children: PropTypes.element.isRequired,
//   /**
//    * Injected by the documentation to work in an iframe.
//    * You won't need it on your project.
//    */
//   window: PropTypes.func,
// };

// function HideOnScroll(props) {
//   const { children, window } = props;
//   // Note that you normally won't need to set the window ref as useScrollTrigger
//   // will default to window.
//   // This is only being set here because the demo is in an iframe.
//   const trigger = useScrollTrigger({
//     target: window ? window() : undefined,
//   });

//   return (
//     <Slide appear={false} direction="down" in={trigger}>
//       {children}
//     </Slide>
//   );
// }

// HideOnScroll.propTypes = {
//   children: PropTypes.element.isRequired,
//   /**
//    * Injected by the documentation to work in an iframe.
//    * You won't need it on your project.
//    */
//   window: PropTypes.func,
// };

const crv_StockSummary = (baseline = {}, payload = {}, crv_code) => {
  const stock_data = payload || [];
  const type = "stock_data"
  let _ = require('lodash');
  let keyMap = {
    c: 'code',
    v: 'value',
    r: 'recordDate',
    rn: 'rn'
  };
  return {
    ...payload,
    // stock_data: stock_data ? stock_data?.map(d => getSeries(undefined, d, type, crv_code)) : undefined,
    stock_data: stock_data ? _?.map(stock_data, (obj) => _?.defaults({}, _?.mapKeys(obj, (value, key) => keyMap[key] || key), { code: crv_code })) : undefined,
  };
};

// const stockTabs = payload => {
//   const { getStockTabs } = payload || {};

//   let keyMap = {
//     c: 'code',
//     v: 'value',
//     r: 'recordDate'
//   };
//   const getTabData = d => {
//     switch (d.type) {
//       case dataConstants.STOCK_SECTION_TYPES.CHART:
//         return d.tabData && d.tabData.length > 0 ? chart(undefined, d.tabData[0]).getChart : undefined;
//       case dataConstants.STOCK_SECTION_TYPES.TICKER_TABLE:
//         return d.tabData && d.tabData.length > 0 ? convertTickerTblFromData({ ...d.tabData[0], tickers: d.tabData[0].tickers ? JSON.parse(d.tabData[0].tickers) : d.tabData[0].tickers }) : undefined;
//       case dataConstants.STOCK_SECTION_TYPES.TABLE_DATA:
//         return d.tabData && d.tabData.length > 0 ? convertTblFromData(d.tabData) : undefined;
//       case "SERIES":
//         // return d?.tabData && d?.tabData?.length > 0 ? d?.tabData?.map(d => getSeries(undefined, d)) : undefined;
//         return d?.tabData && d?.tabData?.length > 0 ? d?.tabData?.map((obj) => {
//           return Object.keys(obj).reduce((acc, key) => {
//             if (keyMap[key]) {
//               acc[keyMap[key]] = obj[key];
//             } else {
//               acc[key] = obj[key];
//             }
//             return acc;
//           }, {})
//         }) : undefined;
//       case "METRICS":
//         return d?.tabData && d?.tabData?.length > 0 ? d?.tabData?.map(d => getMetrics(undefined, d)) : undefined;
//       default:
//         return d.tabData;
//     }
//   }

//   return {
//     getStockTabs: getStockTabs && getStockTabs.length > 0 && getStockTabs.map(d => ({
//       ...d,
//       tabData: getTabData(d),
//       settings: d.settings ? JSON.parse(d.settings) : d.settings,
//     })),
//   };
// }

const Ticker = (props) => {
  // const { asPath } = useRouter();
  const {
    stock_tabs_data, ticker_info, stock_price_data, fair_stock_price_data, chart_theme, stock_news: getNewsfeed,
    themeMode, latest_filings, latest_13g_filings, stock_alerts, isPremium, openDialog, revenues_data, stock_faqs, token,
    chart_events, chart_periods, chart_templates, summary_ranks, heatmapData, heatmapSettings, sector, industry, insider_data,
    fund_data, filings_data, watchlist_metrics,
  } = props || {}
  // const { getStockDataV2 } = stock_price_data || {}
  // const { getStockSummary: getFairValueSummary } = fair_stock_price_data || {}
  const { getLatestFilings } = latest_filings || {}
  const { getStockAlerts } = stock_alerts || {}
  const { getTradingHours, getTickerInfo } = ticker_info || {}
  const { getThemes } = chart_theme || {};
  // const { getNewsfeed } = stock_news || {}
  // const { getStockTabs } = stockTabs(stock_tabs_data) || {};
  const { getStockTabs } = stock_tabs_data || {};
  // const [themes, setThemes] = useState(getThemes && getThemes.map(d => getTheme(undefined, d)))
  // const [tabData, setTabData] = useState(getStockTabs);
  // const [value, setValue] = useState(0);
  // const [alert, setAlert] = useState(false);
  // const [mounted, setMounted] = useState(false)

  // if (!mounted) {
  //   onPageInit(asPath);
  // }

  // useEffect(() => {
  //   setMounted(true)
  // }, [])

  // const tickerTab = asPath && /[^/]*$/.exec(asPath)[0];
  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };
  // const handleAlert = () => {
  //   setAlert(!alert);
  // };
  // const crv_code = `${getTickerInfo?.ticker}.PRICE`
  // const stock_summary = crv_StockSummary(undefined, getStockDataV2, crv_code)
  // const fair_value_5ydata = crv_StockSummary(undefined, getFairValueSummary, crv_code)

  // const type = "Stock_Data"
  // const tickerPriceData = { [Object.keys(ticker_price_data)[0]]: ticker_price_data ? ticker_price_data[Object.keys(ticker_price_data)[0]].map(d => getSeries(undefined, d, type)) : undefined }

  const { ticker } = getTickerInfo || {}

  const desk = isDesktop();

  return (
    <>
      {/* // <Layout toggleColorMode={toggleColorMode} themeMode={themeMode}> */}
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static" sx={{ top: 0, bgcolor: themeMode === 'dark' ? 'background.default' : 'transparent' }} elevation={0}>
          <TickerToolbar
            {...props}
            swrTicker={ticker}
            showOnlyTicker={true}
            tabData={getStockTabs}
            stockAlerts={getStockAlerts}
            ticker={ticker}
            tab={dataConstants.STOCK_TABS.SUM}
            summary_ranks={summary_ranks}
            isPremium={isPremium}
            watchlist_metrics={watchlist_metrics}
          />
          {/* <Box sx={{
              bgcolor: '#fbfbfc',
              '& .MuiTabs-root': { boxShadow: 0 },
              borderBottom: '1px solid #dbdbdb',
              '& .MuiTab-root': {
                color: '#757575 !important',
                transition: 'color 300ms',
                '.MuiSvgIcon-root': {
                  color: '#757575 !important',
                }
              },
              '& .MuiTab-root.Mui-selected': {
                color: '#333 !important', '.MuiSvgIcon-root': {
                  color: '#333 !important',
                }
              },
            }}>
              <StockAppBar
                ticker={ticker}
                value={value}
                handleChange={handleChange}
                centered={false}
              />
            </Box> */}
          {/* <BreadCrumb ticker={ticker} tab={dataConstants.STOCK_TABS.SUM} newStockSumPage={true} /> */}
        </AppBar>
      </Box>
      <Container maxWidth="xl" sx={{ position: 'relative' }}>
        <Box component="div" className="stock-summary-wrapper" sx={{ pt: 0 }}>
          <Summary
            tabData={getStockTabs}
            info={getTickerInfo}
            // data={stock_summary}
            // fairData={fair_value_5ydata}
            getTradingHours={getTradingHours}
            tabCode="SUM"
            themes={getThemes && getThemes.length > 0 ? getThemes.map(d => getTheme(undefined, d)) : []}
            stockNews={getNewsfeed}
            stockAlerts={getStockAlerts}
            latestFilings={getLatestFilings}
            latest_13g_filings={latest_13g_filings}
            isPremium={isPremium}
            token={token}
            openDialog={openDialog}
            revenues_data={revenues_data}
            stock_faqs={stock_faqs}
            chart_events={chart_events}
            chart_periods={chart_periods}
            chart_templates={chart_templates}
            summary_ranks={summary_ranks}
            heatmapSettings={heatmapSettings}
            heatmapData={heatmapData}
            sector={sector}
            industry={industry}
            desk={desk}
            insider_data={insider_data}
            fund_data={fund_data}
            filings_data={filings_data}
            watchlist_metrics={watchlist_metrics}
          />
        </Box>
      </Container >
      {/* <ShowTickerPriceOnScroll {...props}>
        <Box sx={{ minWidth: 332 }}>
          <Card variant="outlined" sx={{ '& .MuiCardContent-root:last-child': { p: 1, } }}>{card}</Card>
        </Box>
      </ShowTickerPriceOnScroll> */}
      {/* <ShowAppBarOnScroll {...props}>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ bgcolor: '#fbfbfc', '& .MuiTabs-root': { boxShadow: 6 } }}>
            <StockAppBar
              ticker={ticker}
              value={value}
              handleChange={handleChange}
              centered={true}
              className={'center'}
            />
          </Box>
        </Box>
      </ShowAppBarOnScroll> */}
      {/* // </Layout> */}
    </>
  );
}


// export async function getStaticPaths() {
//   // Get the paths we want to pre-render based on posts
//   const stockPaths = require('../../../public/assets/search/stock_paths.json');
//   const paths = stockPaths.slice(0, dataConstants.TEN_STOCKS).map(stock => ({
//     params: { ticker: stock.t },
//   }))

//   // We'll pre-render only these paths at build time.
//   // { fallback: false } means other routes should 404.
//   return {
//     // paths: [{ params: { fcik: '1067983' } }, { params: { fcik: '921669' } }],
//     paths,
//     fallback: 'blocking'
//   }
// }
// // export async function getServerSideProps(context) {
// //   const { req, res, params } = context;
// //   res.setHeader(
// //     'Cache-Control',
// //     'public, s-maxage=30, stale-while-revalidate=59'
// //   );

export async function getServerSideProps(context) {
  const { params } = context;
  const ticker_info = (await getTickerInfo(params.ticker)) || [];
  const { ticker, refresh_interval, industry_group, sector, industry } = ticker_info?.getTickerInfo || {}
  // const { sector } = dataConstants.INDUSTRY?.find(d => ((d.shortName === industry_group) || (d.shortName?.includes(industry_group)))) || {};
  const baseUrl = process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : process.env.NEXT_PUBLIC_URL;

  if (!ticker) {
    return {
      notFound: true,
    }
  }

  const date = new Date();
  let _1Y = new Date(date?.setFullYear(date?.getFullYear() - 1));
  _1Y = _1Y?.toISOString()?.substr(0, 10);
  let _5Y = new Date(date?.setFullYear(date?.getFullYear() - 5));
  _5Y = _5Y?.toISOString()?.substr(0, 10);

  // const stocks_data = require('../../../public/assets/search/stock.json');
  // const stock = stocks_data ? stocks_data.find(d => d.t.toUpperCase() === params.ticker.toUpperCase()) : ""
  const stock = await searchTicker({
    url: `${baseUrl}/api/stock-search`,
    searchString: params.ticker,
  }) || [];
  const stock_tabs_data = (await getStockTabs(params.ticker, "NEW_SUM")) || [];

  // const { getStockTabs: insiderData } = (await getStockTabs(params.ticker, "IT", "INSL")) || [];
  // // const insider_data = insiderData && insiderData.length > 0 ? insiderData.find(d => d.section_code === "Latest_Front") : null
  // const insider_data = insiderData && insiderData.length > 0 ? insiderData.find(d => d.section_code === "Latest") : null

  // const { getStockTabs: fundData } = (await getStockTabs(params.ticker, "OWN", "HOLD")) || [];
  // const fund_data = fundData && fundData.length > 0 ? fundData.find(d => d.section_code === "Latest") : null

  const { getRevenues: revenues_data } = (await getRevenues(params.ticker)) || [];
  // const { getLatestFilings: filings_data } = await getLatestFilings(params.ticker) || [];
  // const stock_price_data = (await getPriceData(params.ticker, _1Y)) || [];
  // const fair_stock_price_data = (await get5YPriceData(params.ticker, _5Y)) || [];
  const chart_theme = (await getChartTheme({ type: "Default" })) || []
  // const stock_news = (await getHomeNews(params.ticker, stock?.n1?.replace(/(the| limited| ltd| company| co|[^A-Za-z0-9])/g, " ").trim().split(' ').slice(0, 3).join(' '), type, limit)) || []
  // const stock_news = (await getHomeNews(params.ticker, stock?.n1, type, limit)) || []
  // const stock_news* = await getNewsfeed({ ticker: params.ticker, stock: stock?.n1, funds: 'stock', limit: 9 });
  // const latest_filings = (await getLatestFilings(params.ticker)) || []
  // const _13g_filings = (await get13G(params.ticker)) || []
  const stock_alerts = (await getStockAlerts(params.ticker)) || []
  const stock_faqs = (await getStockFAQs(params.ticker)) || []
  const chart_events = await getEvents(null, null, '');
  const chart_periods = await getPeriods(null, null, '');
  const chart_templates = await getTemplates();
  const { getTickerTextData: summary_ranks } = await getTickerTextData(params.ticker) || {}
  const { getWatchlistMetrics: watchlist_metrics } = await getWatchlistMetrics([params.ticker]) || {};
  // const { getWideScreenerMetricsV3: heatmap_data } = (await getStocksHeatMapData(sector)) || {};
  const heat_tab_data = (await getStockTabs("AAPL", "STOCKHOME", "COLR", null, null, null)) || [];
  const { getStockTabs: _ } = heat_tab_data || {};
  let heatmap_settings = _ && _.length > 0 ? _.find(d => d.section_code === "heatmap") : null;
  const meta_tags = (await getPageMetaTags(`/stock/${params.ticker}`, false)) || {}
  const { getMetaTags } = meta_tags || {}
  // const { get13G: latest_13g_filings } = _13g_filings || {}

  return {
    props: {
      stock_tabs_data,
      ticker_info,
      sector,
      industry,
      chart_theme,
      // stock_price_data,
      // fair_stock_price_data,
      // stock_news: stock_news?.map(item => ({
      //   ...item,
      //   pubDate: item.pubDate.toISOString(),
      // })),
      // latest_filings,
      // latest_13g_filings,
      stock_alerts,
      revenues_data,
      stock_faqs: stock_faqs?.getFAQs || [],
      chart_events,
      watchlist_metrics,
      chart_periods,
      chart_templates,
      summary_ranks,
      // insider_data,
      // fund_data,
      // filings_data,
      // heatmapData: heatmap_data || [],
      heatmapSettings: heatmap_settings || [],
      meta_tags: getMetaTags?.tags || null,
    },
    // revalidate: refresh_interval ?? dataConstants.REVALIDATE_IN.DEFAULT_HOURS,
    // notFound: !ticker ? true : false,
  }
}

// export default Ticker;
export default withProtected(Ticker);
